import React__default, { useState, useRef, useMemo, useEffect, createElement } from 'react';
import { aD as useNavigate } from './className-0524835a.js';

const strongPattern = /\*\*(.+?)\*\*/g;
const emphasisPattern = /\*(.+?)\*/g;
const linkPattern = /\[(.+?)\]\((.+?)\)/g;
const Text = ({ element, children, onLinkClick }) => {
    const navigate = useNavigate();
    const [isHtml, setIsHtml] = useState(false);
    const rootElement = useRef(null);
    const output = useMemo(() => {
        setIsHtml(false);
        return children
            .replace(strongPattern, (matcher, text) => {
            setIsHtml(true);
            return `<strong>${text}</strong>`;
        })
            .replace(emphasisPattern, (matcher, text) => {
            setIsHtml(true);
            return `<em>${text}</em>`;
        })
            .replace(linkPattern, (matcher, text, href) => {
            setIsHtml(true);
            const attrs = [`href="${href}"`];
            if (!href.startsWith('/')) {
                attrs.push('target="_blank"');
            }
            return `<a ${attrs.join(' ')}>${text}</a>`;
        });
    }, [children]);
    // Add click listeners to links.
    useEffect(() => {
        if (rootElement.current === null) {
            return;
        }
        const removeListeners = [];
        for (const link of Array.from(rootElement.current.querySelectorAll('a'))) {
            const href = link.getAttribute('href');
            if (href) {
                const listener = (event) => {
                    onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(event, link);
                    if (!event.defaultPrevented) {
                        // For relative links, update the history object directly to prevent a full page refresh.
                        if (href.startsWith('/')) {
                            event.preventDefault();
                            navigate(href);
                        }
                    }
                };
                link.addEventListener('click', listener);
                removeListeners.push(() => {
                    link.removeEventListener('click', listener);
                });
            }
        }
        return () => {
            removeListeners.forEach(removeListener => removeListener());
        };
    }, [navigate, onLinkClick]);
    if (isHtml) {
        return createElement(element !== null && element !== void 0 ? element : 'span', {
            ref: rootElement,
            dangerouslySetInnerHTML: { __html: output }
        });
    }
    else if (element) {
        return createElement(element, null, output);
    }
    else {
        return React__default.createElement(React__default.Fragment, null, output);
    }
};

export { Text as T };
